import http from "@/http/aisea/axios";
const resource = "/gkmg/vessels/";

export default {
  delete(vesselId) {
    return http.delete(`${resource}${vesselId}/anchors`);
  },
};
